import { render, staticRenderFns } from "./RecruitEdit.vue?vue&type=template&id=b47880ee&scoped=true&"
import script from "./RecruitEdit.vue?vue&type=script&lang=js&"
export * from "./RecruitEdit.vue?vue&type=script&lang=js&"
import style0 from "./RecruitEdit.vue?vue&type=style&index=0&id=b47880ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47880ee",
  null
  
)

export default component.exports